<template>
    <v-dialog
        v-model="dialog"
        persistent
        scrollable
        max-width="900"
    >
        <template #activator="{ on }">
            <v-btn
                v-on="on"
                color="primary"
                rounded
            >
                Buat baru
            </v-btn>
        </template>

        <v-card>
            <v-card-title>Buat soal baru</v-card-title>

            <v-card-text>
                <question-form ref="form"></question-form>
            </v-card-text>

            <v-card-actions>
                <v-checkbox
                    v-model="continueInput"
                    label="Lanjut input soal"
                    color="primary"
                ></v-checkbox>

                <v-spacer></v-spacer>

                <v-btn
                    @click="dialog = false"
                    text
                >
                    Batal
                </v-btn>

                <v-btn
                    @click="save"
                    text
                    color="primary"
                    :loading="$store.get('loader/loading', 'saving')"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import QuestionForm from './QuestionForm'

export default {
    components: {
        QuestionForm,
    },

    data() {
        return {
            dialog: false,
            continueInput: false,
            hasSaveRecently: false,
        }
    },

    watch: {
        dialog(to) {
            if (to) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.form.focus()
                    })
                })
            } else {
                if (this.hasSaveRecently) {
                    this.hasSaveRecently = false
                    this.$store.dispatch(
                        'questionbank/getQuestions',
                        this.$route.params.questionbank_id
                    )
                }
            }
        },
    },

    methods: {
        async save() {
            if (
                this.$store.get('questionbank/input@correctAnswerIdx') === null
            ) {
                return this.$store.dispatch(
                    'flash/warn',
                    'Jawaban benar belum dipilih'
                )
            }

            const data = this.$store.get('questionbank/inputFormData')

            const response = await this.$api.post(
                `questionbank/${this.$route.params.questionbank_id}/question`,
                data,
                { loader: 'saving' }
            )

            if (response.data.created) {
                this.hasSaveRecently = true
                this.$store.dispatch('flash/info', 'Pertanyaan ditambah')

                if (this.continueInput) {
                    this.$refs.form.resetWithPreservedLabelAndField()

                    this.$nextTick(() => {
                        this.$refs.form.flash()
                        this.$refs.form.focus()
                    })
                } else {
                    this.dialog = false
                    this.$refs.form.reset()
                }

                if (
                    this.$store
                        .get('questionbank/labels')
                        .indexOf(data.get('label')) === -1
                ) {
                    this.$store.commit(
                        'questionbank/APPEND_LABEL',
                        data.get('label')
                    )
                }
            } else {
                this.$store.dispatch('flash/genericError')
            }
        },
    },
}
</script>
